import styled from "styled-components";

import colors from "../../assets/css/colors";
import { InputStyle } from "./interface";

export const Input = styled.input<InputStyle>`
  width:100%;
  background: ${colors.white};
  color: ${colors.tertiary};
  border-radius: 7px;
  border: 1px solid ${props => props.isError ? colors.red : "rgba(194, 194, 194, 0.2)"};
  font-size: 0.8em;
  font-weight: 300;
  line-height: 1.45;
  outline: none;
  padding: 0.4em 1em 0.4em;
  -webkit-transition: 0.18s ease-out;
  -moz-transition: 0.18s ease-out;
  -o-transition: 0.18s ease-out;
  transition: 0.18s ease-out;

  -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
  -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
  box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

  &:hover {
    border: 1px solid rgba(255, 169, 89, 0.2);
    -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
  }

  &:focus {
    color: var(--gray);
    border: 1px solid ${colors.secondaryDark};
    -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
  }

  &:disabled {
    background-color: ${colors.grayLightest};
  }

  &::-webkit-input-placeholder {
    text-transform: none;
  }
  &:-moz-placeholder {
    text-transform: none;
  }
  &::-moz-placeholder {
    text-transform: none;
  }
  &:-ms-input-placeholder {
    text-transform: none;
  }
  &::placeholder {
    text-transform: none;
  }
`;

export const Container = styled.div`
  max-width: 100%;
`;

export const SearchResultContainer = styled.div`
  position: absolute;
  width: 100%;
  height: auto;
  z-index: 500;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  background-color: ${colors.white};
  margin-top: -23px;
  top: 55px;
  left: 0px;

  
  -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
  -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
  box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
`;

export const SearchResultItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 7px;
  padding-bottom: 7px;

  &:hover{
    background-color: ${colors.primary};
    color: ${colors.white};
  }
`
